import styled from "styled-components";
import DarkCard from "../../../../../../components/card/DarkCard";
import LightCard from "../../../../../../components/card/LightCard";
import RedHeader from "../../../../../../components/ui/RedBgTitleHeader";
import Staff from "../../../../../../components/project/Staff";
import Events from "../../../../../../components/project/Events";
import { useTranslation } from "react-i18next";
import Rates from "../../../../../../components/project/Rates";
import RentingCosts from "../../../../../../components/project/RentingCosts";
import TransportCosts from "../../../../../../components/project/TransportCosts";
import AdministrationCosts from "../../../../../../components/project/AdministrationCosts";
import ArchivingCosts from "../../../../../../components/project/ArchivingCosts";
import React, {useEffect, useState} from "react";
import {getInstrumentsStaffListAPI,} from "../../../../../../services/api/user";
import {
	archiving_entry,
	archiving_entry_obj,
	archiving_entry_revers,
	name_list_archiving,
	saveCalculation,
	updateCalculation,
	staffValueSum,
	sumAdminCostDetails,
	sumAdminCosts,
	deleteCalculation, quoteCreate,
} from "../helpers/func_helpers";
import {
	ratesCalculation,
	sumRatesClientCost,
} from "../helpers/calculationTotal";
import { calcLocationListAPI } from "../../../../../../services/api/locations";
import {
	getNameColumnTypeStaff,
	getTypeListStaff,
	musiciansCount,
} from "../../../../../../helpers/tools";
import { Button } from "../../../../../../components/ui/Button";
import PopupForm from "../../../../../../components/ui/PopupForm";
import {calculationEditAPI} from "../../../../../../services/api/calculator";
import {useLocation, useNavigate, useParams} from "react-router-dom";
// atrybut "edit" -> caly wiersz jest edytowalny lub nie (desc, costs...)
// atrybut "readOnly" -> pole description jest nieedytowalne / wartosc arybutu brana z db
import { Colors } from "../../../../../../components/theme";
import {Input, InputWrapperDiv} from "../../../../../../components/ui/Input";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faCheckCircle, faPenToSquare} from "@fortawesome/free-solid-svg-icons";
import SlideButton from "../../../../../../components/ui/SlideButton";
import {routesCalcBreadCrumbs, titleHeadLineText, TxtTitles} from "../../../../../../helpers/breadCrumbs";
import Select from "react-select";
import select_styles from "../../../../../../layouts/elements";
import {Alert} from "react-bootstrap";
import useEndpoint from "../../../../../../hooks/useEndpiont";
import {asblSettings, calculator} from "../../../../../../services/api/endpoints";
import {TariffSelect} from "../../../../../../components/project/TariffSelect";
// import {useSessionStorage} from "usehooks-ts";
import { useCalculation } from "../../../../../../hooks/useCalculation";
import {default_tariff} from "../../../../../../hooks/useCalculation/calculationReducer";


const TotalPriceStyle = styled.p`
	font-size: 1.5rem;
	font-weight: bold;
	width: 100%;
	@media (max-width: 575px) {
		font-size: 1.8rem;
	}
`;

const default_value = {'value': '-----', 'label': "-----"}


function Calculator(props)  {
	const { t } = useTranslation();
	const params = useParams();
	const [popup, setPopup] = useState({ show: false, saveUs: false });
	const compositionOptionsInit = [
		{value: "Tutti", label: t("effectif.composition") + "*", color: '#00ace6'},
		// {value: 'Tutti', label: 'Tutti', color: '#00ace6', isDisabled: true}
	];
	const [compositionOptions, setCompositionOptions] = useState(compositionOptionsInit);
	const [locations, setLocations] = useState([]);
	const [calculNameEditInput, setCalculNameEditInput] = useState({
		state: false,
		name: "",
	});
	const [administrationReset, setAdministrationReset] = useState(false);
	const [eventsBooked, setEventsBooked] = useState([]);
	const navigate = useNavigate();
	const [session_data, setSessionData] = useState(JSON.parse(sessionStorage.getItem("CALCULATION")))
	const location = useLocation()
	const [foldersList, setFoldersList] = useState([])
	const [folderTypeSelection, setFolderTypeSelection] = useState("select_folder");
	const [isNotSaved, setIsNotSaved] = useState(false);
	const [tariffNamesOpt, setTariffNamesOpt] = useState([default_value])
	const { makeRequest, loading, error, reset } = useEndpoint();
	const {
		state: calculation,
		setStaff,
		setEvents,
		setEventDetail,
		setDetails,
		setClientKzm,
		setClientMus,
		setEstroKzm,
		setEstroMus,
		setRenting,
		setAdministration,
		setArchiving,
		setTransport,
		setTransp30km,
		setProject30kmAway,
		setConductor30kmAway,
		setKzmProject,
		setConductor,
		setOthers,
		setCalculationName,
		setCalculationNotes,
		setProgram,
		setTariff,
		loadCalculation,
		updateTariffData,
		setFolder,
	} = useCalculation();

	const transp30kmMusicians = transportClone => {
		const musiciansSum = musiciansCount(calculation.staff, calculation.others);
		const musiciansIndex = transportClone.findIndex(el => el.id === "9999");

		if (musiciansIndex > -1) {
			const item9999 = {
				id: "9999",
				description:
					musiciansSum > 0
						? `${calculation.project30kmAway.description} (x ${musiciansSum})`
						: calculation.project30kmAway.description,
				name: calculation.project30kmAway.description,
				client_cost: parseFloat(
					calculation.project30kmAway.client_cost * musiciansSum
				).toFixed(2),
				estro_cost: parseFloat(
					calculation.project30kmAway.estro_cost * musiciansSum
				).toFixed(2),
				cost_type: "transport",
				edit: false,
				display_type: "fullro",
			};
			transportClone.splice(musiciansIndex, 1, item9999);
		}

		if (calculation.conductor > 0 && calculation.transp30km) {
			const item9988 = {
				id: "9988",
				description:
					calculation.conductor > 0
						? `${calculation.conductor30kmAway.description} (x ${calculation.conductor})`
						: calculation.conductor30kmAway.description,
				name: calculation.conductor30kmAway.description,
				client_cost: parseFloat(
					calculation.conductor30kmAway.client_cost * calculation.conductor
				).toFixed(2),
				estro_cost: parseFloat(
					calculation.conductor30kmAway.estro_cost * calculation.conductor
				).toFixed(2),
				cost_type: "transport",
				edit: false,
				display_type: "fullro",
			};
			const conductorIndex = transportClone.findIndex(el => el.id === "9988");
			if (conductorIndex > -1) {
				transportClone.splice(conductorIndex, 1, item9988);
			} else {
				transportClone.unshift(item9988);
			}
		}
		setTransport(transportClone);
	};

	useEffect(() => {
		const getCalculationDetail = async () => {
			try {
				const [resp_events_booked, resp_calculation] = await Promise.all([
					makeRequest(`api/app/events-details-booked/"calculation"/${params.key}`, "GET", null),
					makeRequest(calculator.calculationDetail(params.key), "GET", null)
				]);
				const resp_details = resp_calculation.data;

				if (resp_events_booked) {
					setEventsBooked(resp_events_booked)
				}

				const event_detail = resp_calculation.eventDetails.map(el => {
					return {
						...el,
						eventDate: new Date(el.eventDate),
					};
				});

				const repear_archiving = resp_details.archiving.map(el => {
					if (el.display_type !== "X") {
						return {
							...el,
							"display_type": "archivro",
							"cost_type": "archiving",
							"readOnly": true,
							"edit": false,
							"name": archiving_entry_revers(el.description),
						};
					}
					return el;
				});

				loadCalculation({
					staff: resp_details.staff,
					others: resp_details.others,
					events: resp_details.events,
					eventDetail: event_detail,
					details: resp_details.details,
					costs: {
						administration: resp_details.administration,
						archiving: repear_archiving,
						renting: resp_details.renting,
						transport: resp_details.transport,
					},
					rates: {
						client: {
							kzm: resp_details.clientKzm,
							mus: resp_details.clientMus,
						},
						estro: {
							kzm: resp_details.estroKzm,
							mus: resp_details.estroMus,
						}
					},
					conductor: resp_details.conductor,
					eventDuration: resp_details.eventDuration,
					kzmProject: resp_details.kzmProject,
					project30kmAway: resp_details.project30kmAway,
					conductor30kmAway: resp_details.conductor30kmAway,
					transp30km: resp_details.transp30km,
					calculationName: resp_calculation.name,
					folder: resp_details.folder,
					calculationNotes: resp_details.calculationNotes ? resp_details.calculationNotes : "",
					program: resp_details.program ? resp_details.program : "",
					tariff: resp_details.tariff?.id > 0 ? resp_details.tariff : default_tariff,
				});

				setCalculNameEditInput({
					state: false,
					name: resp_calculation.name,
				});

				if (session_data) {
					setSessionData({
						...session_data,
						currentFirst: session_data.estimateCurrent,
						program: resp_calculation.program,
					})
				}
			} catch (e) {
				console.error(e);
				navigate("/sales/saved_calculations");
			}

			// location options
			try {
				const resplist = await calcLocationListAPI();
				const data = resplist.data.qs.map(el => {
					return {
						value: el.name,
						label: el.name,
						pk: el.pk,
					};
				});
				data.unshift({
					value: "to_define",
					label: t("location.to_define"),
					pk: "",
				});
				setLocations(data);
			} catch (ex) {
				console.log("Failed to download locations list.", ex);
			}
		};

		const new_calculation = async () => {
			try {
				const settingsResp = await makeRequest(
					asblSettings.asblSettingsByName(default_tariff.value),
					"GET",
					null
				);

				const other_cost_type = settingsResp.other_cost_type;
				const resultDuration = {
					rehearsal_duration: +settingsResp.rehearsal_duration,
					raccord_duration: +settingsResp.raccord_duration,
					break_after_raccord_duration: +settingsResp.break_after_raccord_duration,
					min_raccord_duration: +settingsResp.min_raccord_duration,
					late_arrival_fee_deduction: +settingsResp.late_arrival_fee_deduction,
				};

				const result = other_cost_type.filter(
					type => type.cost_type === "renting"
				);

				const resultAdministration = other_cost_type.filter(
					type => type.cost_type === "administration"
				);
				const resultAdmin = resultAdministration.map(el => ({
					...el,
					["edit"]: true,
				}));

				const resultArch = other_cost_type.filter(
					type => type.cost_type === "archiving"
				);

				const archiving_data = [];
				name_list_archiving.forEach(name => {
					const result_item = resultArch.find(el => el.description === name);
					if (result_item) {
						result_item.name = name;
						result_item.description = archiving_entry(t, name).desc;
						result_item.display_type = "archivro";
						result_item.amount = 0;
						result_item.entity = archiving_entry(t, name).entity;
						result_item.edit = false;
						result_item.unit_client_cost = result_item.client_cost;
						result_item.unit_estro_cost = result_item.estro_cost;
						result_item.client_cost = "0.00";
						result_item.estro_cost = "0.00";
						archiving_data.push(result_item);
					}
				});

				const result_rest_name = resultArch.filter(
					el => !name_list_archiving.includes(el.name)
				);
				const rest_resultArch_data = result_rest_name.map(el => {
					return archiving_entry_obj(t, el, el.display_type);
				});
				archiving_data.push(...rest_resultArch_data);

				const resultTransp = other_cost_type.filter(
					type => type.cost_type === "transport"
				);
				const resultTransport = resultTransp.map(el => ({
					...el,
					["edit"]: true,
				}));

				let project30kmAwayData = { description: "Musicians", client_cost: 0, estro_cost: 0, name: "Musicians" };
				const musiciansIndex = resultTransport.findIndex(
					el => el.description.toLowerCase() === "musicians"
				);
				if (musiciansIndex > -1) {
					const projectItem = resultTransport[musiciansIndex];
					project30kmAwayData = {
						description: projectItem.description,
						client_cost: projectItem.client_cost,
						estro_cost: projectItem.estro_cost,
						name: projectItem.description,
					};
					resultTransport.splice(musiciansIndex, 1);
				}

				let conductor30kmAwayData = { description: "Conductor", client_cost: 0, estro_cost: 0, name: "Conductor" };
				const conductorIndex = resultTransport.findIndex(
					el => el.description.toLowerCase() === "conductor"
				);
				if (conductorIndex > -1) {
					const conductorItem = resultTransport[conductorIndex];
					conductor30kmAwayData = {
						description: conductorItem.description,
						client_cost: conductorItem.client_cost,
						estro_cost: conductorItem.estro_cost,
						name: conductorItem.description,
					};
					resultTransport.splice(conductorIndex, 1);
				}

				const resultAdminFirstEntry = {
					id: "ADMIN_WORK",
					description: "Administrator work",
					client_cost: "0.00",
					estro_cost: "0.00",
					cost_type: "administration",
					edit: false,
					display_type: "fullro",
				};
				resultAdmin.unshift(resultAdminFirstEntry);

				// Załaduj wszystkie dane dla nowej kalkulacji
				loadCalculation({
					staff: {}, // Będzie załadowane z API poniżej
					others: "",
					conductor: "",
					events: { rehearsals: 0, raccords: 0, concerts: 0 },
					eventDetail: [],
					details: false,
					costs: {
						renting: result,
						administration: resultAdmin,
						transport: resultTransport,
						archiving: archiving_data,
					},
					rates: {
						client: {
							kzm: {
								rehearsals: parseFloat(settingsResp.client_rate_kzm_rehearsal),
								raccords: parseFloat(settingsResp.client_rate_kzm_raccord),
								concerts: parseFloat(settingsResp.client_rate_kzm_concert),
							},
							mus: {
								rehearsals: parseFloat(settingsResp.client_rate_mus_rehearsal),
								raccords: parseFloat(settingsResp.client_rate_mus_raccord),
								concerts: parseFloat(settingsResp.client_rate_mus_concert),
							}
						},
						estro: {
							kzm: {
								rehearsals: parseFloat(settingsResp.estro_rate_kzm_rehearsal),
								raccords: parseFloat(settingsResp.estro_rate_kzm_raccord),
								concerts: parseFloat(settingsResp.estro_rate_kzm_concert),
							},
							mus: {
								rehearsals: parseFloat(settingsResp.estro_rate_mus_rehearsal),
								raccords: parseFloat(settingsResp.estro_rate_mus_raccord),
								concerts: parseFloat(settingsResp.estro_rate_mus_concert),
							}
						}
					},
					eventDuration: resultDuration,
					kzmProject: true,
					transp30km: false,
					project30kmAway: project30kmAwayData,
					conductor30kmAway: conductor30kmAwayData,
					calculationName: "",
					calculationNotes: "",
					tariff: default_tariff,
					folder: null,
				});
			} catch (ex) {
				console.log("Failed to download settings", ex);
			}

			try {
				const responseInstrumentsStaff = await getInstrumentsStaffListAPI();
				const instrStaffResp = responseInstrumentsStaff.data;
				delete instrStaffResp["Violin"];
				Object.keys(instrStaffResp).forEach(el => {
					const instrTypeName = getNameColumnTypeStaff(el);
					instrStaffResp[el].type = instrTypeName;
				});
				setStaff(instrStaffResp);
			} catch (ex) {
				console.log("Failed to download instruments staff list.");
			}

			try {
				const resplist = await calcLocationListAPI();
				const data = resplist.data.qs.map(el => {
					return {
						value: el.name,
						label: el.name,
						pk: el.pk,
					};
				});
				data.unshift({
					value: "to_define",
					label: t("location.to_define"),
					pk: "",
				});
				setLocations(data);
			} catch (ex) {
				console.log("Failed to download locations list.", ex);
			}
		};

		if (params.hasOwnProperty("key")) {
			getCalculationDetail();
		} else {
			new_calculation();
			if (!session_data) {
				setSessionData(null)
			}
		}

		const getFoldersListAPI = async () => {
			try {
				const [folderList, tariffNames] = await Promise.all([
					makeRequest(calculator.foldersList, "GET", null),
					makeRequest(asblSettings.abslSaveSettingsListName, "GET", null)
				]);
				setTariffNamesOpt(tariffNames)
				const data = folderList.folders.map(el => ({'value': el, 'label': el}));
				setFoldersList([default_value, ...data]);
			} catch (e) {
				console.error(e);
				navigate('/network-error');
			}
		}
		getFoldersListAPI();

		return () => reset()
	}, [params.key]);

	useEffect(() => {
		if (!calculation.tariff || calculation.tariff.id === 0) return;
		if (params.key && calculation.tariff.id && !isNotSaved) return;

		const updateTariff = async () => {
			try {
				const settingsResp = await makeRequest(
					asblSettings.asblSettingsByName(calculation.tariff.value),
					"GET",
					null
				);

				const other_cost_type = settingsResp.other_cost_type;

				// Przygotuj renting
				const resultRenting = other_cost_type.filter(
					type => type.cost_type === "renting"
				);

				// Przygotuj administration
				const resultAdministration = other_cost_type
					.filter(type => type.cost_type === "administration")
					.map(el => ({ ...el, edit: true }));

				const resultAdminFirstEntry = {
					id: "ADMIN_WORK",
					description: "Administrator work",
					client_cost: "0.00",
					estro_cost: "0.00",
					cost_type: "administration",
					edit: false,
					display_type: "fullro",
				};
				resultAdministration.unshift(resultAdminFirstEntry);

				// Przygotuj archiving
				const resultArch = other_cost_type.filter(
					type => type.cost_type === "archiving"
				);
				const archiving_data = [];
				name_list_archiving.forEach(name => {
					const result_item = resultArch.find(el => el.description === name);
					if (result_item) {
						result_item.name = name;
						result_item.description = archiving_entry(t, name).desc;
						result_item.display_type = "archivro";
						result_item.amount = 0;
						result_item.entity = archiving_entry(t, name).entity;
						result_item.edit = false;
						result_item.unit_client_cost = result_item.client_cost;
						result_item.unit_estro_cost = result_item.estro_cost;
						result_item.client_cost = "0.00";
						result_item.estro_cost = "0.00";
						archiving_data.push(result_item);
					}
				});
				const result_rest_name = resultArch.filter(
					el => !name_list_archiving.includes(el.name)
				);
				const rest_resultArch_data = result_rest_name.map(el => {
					return archiving_entry_obj(t, el, el.display_type);
				});
				archiving_data.push(...rest_resultArch_data);

				// Przygotuj transport
				const resultTransp = other_cost_type
					.filter(type => type.cost_type === "transport")
					.map(el => ({ ...el, edit: true }));

				let project30kmAwayData = calculation.project30kmAway;
				const musiciansIndex = resultTransp.findIndex(
					el => el.description.toLowerCase() === "musicians"
				);
				if (musiciansIndex > -1) {
					const projectItem = resultTransp[musiciansIndex];
					project30kmAwayData = {
						description: projectItem.description,
						client_cost: projectItem.client_cost,
						estro_cost: projectItem.estro_cost,
						name: projectItem.description,
					};
					resultTransp.splice(musiciansIndex, 1);
				}

				let conductor30kmAwayData = calculation.conductor30kmAway;
				const conductorIndex = resultTransp.findIndex(
					el => el.description.toLowerCase() === "conductor"
				);
				if (conductorIndex > -1) {
					const conductorItem = resultTransp[conductorIndex];
					conductor30kmAwayData = {
						description: conductorItem.description,
						client_cost: conductorItem.client_cost,
						estro_cost: conductorItem.estro_cost,
						name: conductorItem.description,
					};
					resultTransp.splice(conductorIndex, 1);
				}

				// aktualizuje wszystko
				updateTariffData({
					rates: {
						client: {
							kzm: {
								rehearsals: parseFloat(settingsResp.client_rate_kzm_rehearsal),
								raccords: parseFloat(settingsResp.client_rate_kzm_raccord),
								concerts: parseFloat(settingsResp.client_rate_kzm_concert),
							},
							mus: {
								rehearsals: parseFloat(settingsResp.client_rate_mus_rehearsal),
								raccords: parseFloat(settingsResp.client_rate_mus_raccord),
								concerts: parseFloat(settingsResp.client_rate_mus_concert),
							}
						},
						estro: {
							kzm: {
								rehearsals: parseFloat(settingsResp.estro_rate_kzm_rehearsal),
								raccords: parseFloat(settingsResp.estro_rate_kzm_raccord),
								concerts: parseFloat(settingsResp.estro_rate_kzm_concert),
							},
							mus: {
								rehearsals: parseFloat(settingsResp.estro_rate_mus_rehearsal),
								raccords: parseFloat(settingsResp.estro_rate_mus_raccord),
								concerts: parseFloat(settingsResp.estro_rate_mus_concert),
							}
						}
					},
					eventDuration: {
						rehearsal_duration: +settingsResp.rehearsal_duration,
						raccord_duration: +settingsResp.raccord_duration,
						break_after_raccord_duration: +settingsResp.break_after_raccord_duration,
						min_raccord_duration: +settingsResp.min_raccord_duration,
						late_arrival_fee_deduction: +settingsResp.late_arrival_fee_deduction,
					},
					costs: {
						renting: resultRenting,
						administration: resultAdministration,
						transport: resultTransp,
						archiving: archiving_data,
					},
					project30kmAway: project30kmAwayData,
					conductor30kmAway: conductor30kmAwayData,
				});

				setIsNotSaved(true);
			} catch (ex) {
				console.error("Failed to update tariff data", ex);
			}
		};

		updateTariff();
	}, [calculation.tariff.id]);

	useEffect(() => {
		const hanndleRouterChange = () => {
			sessionStorage.removeItem("CALCULATION")
		}
		return () => {
			hanndleRouterChange()
		}
	}, [location])

	useEffect(() => {
		const transportClone = structuredClone(calculation.costs.transport);
		if (calculation.transp30km) {
			const musiciansSum = musiciansCount(calculation.staff, calculation.others);
			transportClone.unshift({
				id: "9999",
				description:
					musiciansSum > 0
						? `${calculation.project30kmAway.description} (x ${musiciansSum})`
						: calculation.project30kmAway.description,
				name: calculation.project30kmAway.description,
				client_cost: parseFloat(
					calculation.project30kmAway.client_cost * musiciansSum
				).toFixed(2),
				estro_cost: parseFloat(
					calculation.project30kmAway.estro_cost * musiciansSum
				).toFixed(2),
				cost_type: "transport",
				edit: false,
				display_type: "fullro",
			});

			if (calculation.conductor > 0) {
				transportClone.unshift({
					id: "9988",
					description: `${calculation.conductor30kmAway.description} (x ${calculation.conductor})`,
					name: calculation.conductor30kmAway.description,
					client_cost: parseFloat(
						calculation.conductor30kmAway.client_cost * calculation.conductor
					).toFixed(2),
					estro_cost: parseFloat(
						calculation.conductor30kmAway.estro_cost * calculation.conductor
					).toFixed(2),
					cost_type: "transport",
					edit: false,
					display_type: "fullro",
				});
			}
		} else {
			const indexDel = transportClone.findIndex(el => el.id === "9999");
			if (indexDel > -1) {
				transportClone.splice(indexDel, 1);
			}

			const indexConductorDel = transportClone.findIndex(
				el => el.id === "9988"
			);
			if (indexConductorDel > -1) {
				transportClone.splice(indexConductorDel, 1);
			}
		}
		setTransport(transportClone);
	}, [calculation.transp30km]);

	useEffect(() => {
		const selectedStaff = getTypeListStaff(calculation.staff, calculation.others);
		setCompositionOptions(selectedStaff);

		const transportClone = structuredClone(calculation.costs.transport);
		transp30kmMusicians(transportClone);
	}, [calculation.staff, calculation.others]);

	useEffect(() => {
		const transportClone = structuredClone(calculation.costs.transport);
		transp30kmMusicians(transportClone);
	}, [calculation.conductor]);

	useEffect(() => {
		const adminClone = structuredClone(calculation.costs.administration);
		const adminIndex = adminClone.findIndex(el => el.id === "ADMIN_WORK");

		if (adminIndex > -1) {
			let data = {};
			if (calculation.details) {
				data = {
					events: calculation.eventDetail,
					client_rehearsals: calculation.rates.client.mus.rehearsals,
					client_raccords: calculation.rates.client.mus.raccords,
					client_concerts: calculation.rates.client.mus.concerts,
					rehearsals_duration: calculation.eventDuration.rehearsal_duration,
					raccords_duration: calculation.eventDuration.raccord_duration,
				};
				const adminItem = { ...adminClone[adminIndex] };
				adminItem.client_cost = sumAdminCostDetails(data);
				adminClone.splice(adminIndex, 1, adminItem);
				setAdministration(adminClone);
			} else {
				data = {
					count_rehearsals: calculation.events.rehearsals,
					count_raccords: calculation.events.raccords,
					count_concerts: calculation.events.concerts,
					client_rehearsals: calculation.rates.client.mus.rehearsals,
					client_raccords: calculation.rates.client.mus.raccords,
					client_concerts: calculation.rates.client.mus.concerts,
				};
				const adminItem = { ...adminClone[adminIndex] };
				adminItem.client_cost = sumAdminCosts(data);
				adminClone.splice(adminIndex, 1, adminItem);
				setAdministration(adminClone);
			}
		}
	}, [calculation.events, calculation.rates.client.mus, calculation.eventDetail, administrationReset]);

	useEffect(() => {
		if (!calculation.kzmProject) {
			const eventDetailCopy = structuredClone(calculation.eventDetail);
			eventDetailCopy.forEach(el => (el.kzmEvent = false));
			setEventDetail(eventDetailCopy);
		}
	}, [calculation.kzmProject]);

	useEffect(() => {
		const transportClone = structuredClone(calculation.costs.transport);
		transp30kmMusicians(transportClone);
	}, [calculation.project30kmAway, calculation.conductor30kmAway]);



	const calculation_data = {
		clientKzm: calculation.rates.client.kzm,
		clientMus: calculation.rates.client.mus,
		estroKzm: calculation.rates.estro.kzm,
		estroMus: calculation.rates.estro.mus,
		staff: calculation.staff,
		events: calculation.events,
		details: calculation.details,
		eventDetail: calculation.eventDetail,
		eventDuration: calculation.eventDuration,
		kzmProject: calculation.kzmProject,
		renting: calculation.costs.renting,
		administration: calculation.costs.administration,
		transport: calculation.costs.transport,
		archiving: calculation.costs.archiving,
		conductor: calculation.conductor,
		others: calculation.others,
		folder: calculation.folder,
		tariff: calculation.tariff,
	};

	const staffSum = staffValueSum(calculation.staff, calculation.others);
	const ratesSumCalculate = ratesCalculation(calculation_data, staffSum);

	const { clientSum, estroSum, totalSum } = sumRatesClientCost(
		calculation_data,
		staffSum,
		ratesSumCalculate
	);

	const handlePopup = async obj => {
		if (obj.type === "cancel") {
			setPopup({ show: false });
			return
		}
		if (obj.type === "ok") {
			if (session_data) {
				navigate(session_data.pathReturn);
				return
			}
			navigate("/sales/calculator/" + popup.id);
			setPopup({ show: false });
			setIsNotSaved(false);
			return;
		}
		if (obj.type === "save") {
			// Dodaj pola które były poza calculation_data
			calculation_data["transp30km"] = calculation.transp30km;
			calculation_data["project30kmAway"] = calculation.project30kmAway;
			calculation_data["conductor30kmAway"] = calculation.conductor30kmAway;
			calculation_data["calculationNotes"] = calculation.calculationNotes;
			calculation_data["program"] = calculation.program;
			calculation_data["totaling"] = {
				ratesSum: ratesSumCalculate,
				staffSum: staffSum,
				clientSum: clientSum,
				estroSum: estroSum,
				grantEstroSum: estroSum - clientSum > 0
					? (estroSum - clientSum).toFixed(2)
					: '0.00',
				totalSum: totalSum,
			}
			if (calculation_data.eventDetail.length > 0) {
				const eventDetailCopy = structuredClone(calculation_data.eventDetail)
				eventDetailCopy.forEach(obj => {
					if ( (!obj.composition) || (obj.composition.length === 0) ) {
						obj['composition'] = [{value: 'Tutti', label: 'Tutti'}]
					}
				})
				calculation_data.eventDetail = eventDetailCopy
			}

			try {
				if (session_data && session_data.name) {
					calculation_data.session_data = session_data
				}

				if (params.key) {
					if (popup.saveUs) {
						const response_update = await updateCalculation(
							calculation_data,
							calculation.calculationName,
							params.key
						);
						if (response_update.popupData.variant === "error") {
							setPopup(response_update.popupData);
							return;
						}

						calculation_data["calculation_name"] = obj.inputValue.calculation_name;
						const response_save = await saveCalculation(
							calculation_data,
							obj.inputValue.calculation_name
						);
						setPopup(response_save.popupData);
						return;
					} else {
						const response_save_current_calc = await updateCalculation(
							calculation_data,
							calculation.calculationName,
							params.key
						);

						if ((response_save_current_calc.events_no_free_links) && (response_save_current_calc.events_no_free_links.length > 0)) {
							const eventDetail_copy = structuredClone(calculation.eventDetail)
							response_save_current_calc.events_no_free_links.forEach(no_free_obj => {
								const eventItem = eventDetail_copy.find(el => el.key === no_free_obj.event_key)
								if (eventItem) {
									eventItem.isFree = false
									eventItem.noFreeLinks = no_free_obj.link
								}
							})
							setEventDetail(eventDetail_copy)
						}
						setPopup({...response_save_current_calc.popupData, id: response_save_current_calc.id});
						return;
					}
				} else {
					const response = await saveCalculation(
						calculation_data,
						obj.inputValue.calculation_name
					);
					setPopup({...response.popupData, id: response.id});
				}
			} catch (e) {
				console.log(e);
				setPopup({
					show: true,
					variant: "error",
					title: "popups.error_save_data.title",
					message: "popups.error_save_data.message",
					okBtn: "OK",
				});
				return;
			}
		}
	};

	const saveHandler = async save_opt => {
		if (calculation.tariff.id === 0) return

		if (params.key) {
			if (save_opt === "save_as") {
				if (session_data) {
					setSessionData({...session_data, action: "project_create_estimate"});
				}
				setPopup({
					show: true,
					variant: "editF",
					title: t("calculator.saving_calcul_popup_title"),
					message: "calculator.saving_calcul_popup_message",
					type: "formular",
					context: {
						label: t("calculator.calculation_name.field_title"),
						calculation_name: "XXX",
					},
					leftBtn: t("common.button.save"),
					rightBtn: t("common.button.cancel"),
					saveUs: calculation.costs.transport,
				});
			} else {
				const obj = {
					type: "save",
					inputValue: { calculation_name: calculation.calculationName },
					save_opt: save_opt,
				};
				handlePopup(obj);
			}
		} else {
			setPopup({
				show: true,
				variant: "editF",
				title: session_data ? t("popups.estimate.save_new_title") : t("calculator.saving_calcul_popup_title"),
				message: session_data ? t("popups.estimate.save_new_name") : t("calculator.saving_calcul_popup_message"),
				type: "formular",
				context: {
					label: t("calculator.calculation_name.field_title"),
					calculation_name: "XXX",
				},
				leftBtn: t("common.button.save"),
				rightBtn: t("common.button.cancel"),
				saveUs: false,
			});
		}
	};

	const handleCalculDelete = async obj => {
		if (obj.type === "cancel") {
			setPopup({ show: false });
			return;
		}
		if (obj.type === "ok") {
			const response = await deleteCalculation(navigate, params.key);
			if (response.status === 204) {
				if (session_data) {
					navigate(session_data.pathReturn);
				} else navigate('/sales/saved_calculations')
			}
			if (response.popupData) {
				setPopup(response.popupData);
			}
			return;
		}

		setPopup({
			show: true,
			variant: "editF",
			/* Show if an estimate should be deleted or calulation */
			title: session_data ? t("popups.estimate.delete_title") : t("calculator.delete_calcul_popup_title"),
			message: session_data ? t("popups.estimate.delete_message") : t("calculator.delete_calcul_popup_message"),
			type: "delete",
			okBtn: t("common.button.delete"),
			rightBtn: t("common.button.cancel"),
			deleteStatus: true,
		})
	};

	const handleInputNameChange = e => {
		setCalculNameEditInput({ state: true, name: e });
	};

	const handleNameEdit = async () => {
		setCalculNameEditInput({ state: true, name: calculation.calculationName });
	};

	const handleNameCancel = () => {
		setCalculNameEditInput({ state: false, name: calculation.calculationName });
	};

	const handleNameSave = async () => {
		try {
			const response = await calculationEditAPI(
				{ name: calculNameEditInput.name },
				params.key
			);
			if (response.status === 200) {
				const newNameState = structuredClone(calculNameEditInput);
				setCalculNameEditInput({ ...newNameState, state: false });
				setCalculationName(calculNameEditInput.name);
			}
		} catch (e) {
			console.error(e);
		}
	};

	const handleOffer = async () => {
		// save calculation
		await handlePopup({type: "save"})
		await sessionStorage.clear()
		await sessionStorage.setItem("offer_processName", "estimate")
		navigate("/projects/offer/" + params.key, {replace: true});
	};

	const handleQuote = async () => {
		const response = await quoteCreate(session_data.estimateID);
		setPopup({
			...response.popupData,
			title: t("popups.quote.title_created"),
			message: t("popups.quote.message_created")
		})
	}

	const changeEstimateCurrent = (val) => {
		setSessionData({
			...session_data,
			estimateCurrent: val,
		})
	}

	const calculation_name_create = () => {
		if (session_data && session_data.action === "project_create_estimate") {
			return t("calculator.new_estimation")
		}
		return t("calculator.new_calculation")
	}

	const radioButtonHandle = (opt) => {
		setFolderTypeSelection(opt);
		if (opt === 'new_folder') {
			setFolder("")
		}
	}

	const tariffHandler = (val) => {
		setTariff(val);
		setIsNotSaved(true);
	}

	return (<>
		<div style={{position: 'fixed', top: 50, left: 0, width: '100%', zIndex: 150, textAlign:'center'}}>
			<Alert key="warning-alert" variant="danger" show={isNotSaved} style={{width:'50%', margin:'0 auto', padding:'10px'}}>
				{t("popups.calulator.data_changed")}
				<Button
					className='m-0 p-1 ms-4'
					variant='round'
					style={{backgroundColor: `${Colors.green}`}}
					name='save'
					onClick={() => saveHandler("save")}>
					{t("common.button.save")}
				</Button>
			</Alert>
		</div>

		<DarkCard classNames='mb-3 row'>
			{session_data
				? routesCalcBreadCrumbs(t, session_data.action, session_data.projectID, session_data.estimateID, session_data.calculationID)
				: routesCalcBreadCrumbs(t, params.key ? "saved_calculation" : "new_calculation", 0, 0, params.key)
			}
		</DarkCard>
		<DarkCard classNames='mb-3 row'>
			{titleHeadLineText(t, session_data, params.key)}
			<h1 className='mt-0 p-0'>
				{params.key ? (
					<div>
						{calculation.calculationName}
						{calculNameEditInput.state ? (
							<div>
								<Input
									name='editNameCalculation'
									value={calculNameEditInput.name}
									type={"text"}
									style={{minWidth: "250px", width: "50%"}}
									onChange={handleInputNameChange}
								/>
								<Button
									onClick={handleNameSave}
									bWidth='small'
									className='mx-2'
									style={{backgroundColor: `${Colors.green}`}}>
									{t("common.button.save")}
								</Button>
								<Button
									onClick={handleNameCancel}
									variant='square'
									bWidth='small'
									styling='bordered'
									className='mx-2'>
									{t("common.button.cancel")}
								</Button>
							</div>
						) : (
							<a className='ms-3'
							   style={{fontSize: "20px"}}
							   name='editName'
							   onClick={handleNameEdit}>
								<FontAwesomeIcon icon={faPenToSquare}/>
							</a>
						)}
					</div>
				) : (
					<div>
						{calculation_name_create()}
					</div>
				)}
			</h1>

			<TariffSelect
				newTariff={calculation.tariff}
				optList={tariffNamesOpt}
				onChangeTariff={tariffHandler}
			/>

			{calculation.tariff && calculation.tariff.value !== default_tariff.value && (
				<>
				<LightCard classNames='mb-3'>
					<RedHeader
						title={t("effectif.title") + " ( " + musiciansCount(calculation.staff, calculation.others) + " )"}
					/>
					<Staff
						fieldNameList={calculation.staff}
						setStaff={setStaff}
						eventDetail={calculation.eventDetail}
						setEventDetail={setEventDetail}
						renting={calculation.costs.renting}
						setRenting={setRenting}
						transport={calculation.costs.transport}
						setTransport={setTransport}
						kzmProject={calculation.kzmProject}
						setKzmProject={setKzmProject}
						conductor={calculation.conductor}
						setConductor={setConductor}
						others={calculation.others}
						setOthers={setOthers}
						setIsNotSaved={setIsNotSaved}
					/>
				</LightCard>

				<LightCard classNames='mb-3'>
					<RedHeader title={t("events.title")} />
					<Events
						events={calculation.events}
						setEvents={setEvents}
						eventDetail={calculation.eventDetail}
						setEventDetail={setEventDetail}
						staff={calculation.staff}
						compositionOptions={compositionOptions}
						setCompositionOptions={setCompositionOptions}
						details={calculation.details}
						setDetails={setDetails}
						kzmProject={calculation.kzmProject}
						locations={locations}
						params={params}
						conductor={calculation.conductor}
						others={calculation.others}
						eventsBooked={eventsBooked}
						setIsNotSaved={setIsNotSaved}
					/>
				</LightCard>

				<LightCard classNames='mb-3'>
					<Rates
						clientKzm={calculation.rates.client.kzm}
						clientMus={calculation.rates.client.mus}
						estroKzm={calculation.rates.estro.kzm}
						estroMus={calculation.rates.estro.mus}
						setClientKzm={setClientKzm}
						setClientMus={setClientMus}
						setEstroKzm={setEstroKzm}
						setEstroMus={setEstroMus}
						ratesCalculation={ratesSumCalculate}
						setIsNotSaved={setIsNotSaved}
					/>
				</LightCard>

				<LightCard classNames='mb-3'>
					<div className='row'>
						<div className='col-xl-6'>
							<RedHeader title={t("renting.title")} />
							<RentingCosts
								cost={calculation.costs.renting}
								setCost={setRenting}
								typeCost='renting'
								staff={calculation.staff}
								setStaff={setStaff}
								setIsNotSaved={setIsNotSaved}
							/>
						</div>
						<div className='col-xl-6 mt-3 mt-xl-0'>
							<RedHeader title={t("transport.title")} />
							<TransportCosts
								transp30km={calculation.transp30km}
								setTransp30km={setTransp30km}
								transport={calculation.costs.transport}
								setTransport={setTransport}
								project30kmAway={calculation.project30kmAway}
								setProject30kmAway={setProject30kmAway}
								conductor30kmAway={calculation.conductor30kmAway}
								setConductor30kmAway={setConductor30kmAway}
								type='transport'
								staff={calculation.staff}
								others={calculation.others}
								setIsNotSaved={setIsNotSaved}
							/>
						</div>
					</div>
				</LightCard>

				<LightCard classNames='mb-3'>
					<div className='row'>
						<div className='col-xl-6'>
							<RedHeader title={t("administration.title")} />
							<AdministrationCosts
								administration={calculation.costs.administration}
								setAdministration={setAdministration}
								type='administration'
								administrationReset={administrationReset}
								setAdministrationReset={setAdministrationReset}
								setIsNotSaved={setIsNotSaved}
							/>
						</div>
						<div className='col-xl-6 mt-3 mt-xl-0'>
							<RedHeader title={t("archiving.title")} />
							<ArchivingCosts
								archiving={calculation.costs.archiving}
								setArchiving={setArchiving}
								type='archiving'
								setIsNotSaved={setIsNotSaved}
							/>
						</div>
					</div>
				</LightCard>

				<LightCard classNames='mb-3'>
					<RedHeader title={t("common.titles.total")} />
					<div className='row px-2'>
						<div className='col-sm-3 txtCenter'>
							<p><u>{t("rates.clients_costs")}</u></p>
							<TotalPriceStyle>
								{clientSum > 0 ? clientSum.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") : 0} €
							</TotalPriceStyle>
						</div>
						<div className='col-sm-3 txtCenter'>
							<p><u>{t("rates.estros_costs")}</u></p>
							<TotalPriceStyle>{estroSum > 0 ? estroSum.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") : 0} €</TotalPriceStyle>
						</div>
						<div className='col-sm-3 txtCenter'>
							<p><u>{t("rates.estro_grant")}</u></p>
							<TotalPriceStyle>
								{parseFloat(
									estroSum - clientSum > 0 ? (estroSum - clientSum) : 0
								).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, " ")} €
							</TotalPriceStyle>
						</div>
						<div className='col-sm-3 txtCenter'>
							<p><u>{t("rates.total_costs")}</u></p>
							<TotalPriceStyle>{totalSum > 0 ? totalSum.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") : 0} €</TotalPriceStyle>
						</div>
					</div>
				</LightCard>

				</>
			)}
		</DarkCard>

		<DarkCard classNames='mb-3 row'>
			<LightCard classNames='mb-3'>
				<RedHeader title={t("common.titles.calc_notes")} />
				<textarea
					name={"calcNotes"}
					value={calculation.calculationNotes}
					onChange={e => {
						setCalculationNotes(e.target.value);
						setIsNotSaved(true)
					}}
					rows={6}
					style={{ width: "100%", fontSize: "19px" }}
				/>
			</LightCard>

			{session_data &&
				<LightCard>
					<RedHeader title={t("common.titles.project_program")} />
					<textarea
						name={"program"}
						value={calculation.program}
						onChange={e => {
							setProgram(e.target.value);
							setIsNotSaved(true)
						}}
						rows={6}
						style={{ width: "100%", fontSize: "19px" }}
					/>
				</LightCard>
			}
		</DarkCard>

		{session_data
			? !session_data.currentFirst
				? <DarkCard classNames='mb-3 row'>
					<div className="col-sm-12 col-xl-2 mb-2">
						<InputWrapperDiv>
							<TxtTitles>
								{t("project.define_estimate_as_basis_title")}
							</TxtTitles>
							<SlideButton
								type='yesNo'
								val={session_data.estimateCurrent}
								setVal={val => changeEstimateCurrent(val)}
								setIsNotSaved={setIsNotSaved}
							/>
						</InputWrapperDiv>
					</div>
				</DarkCard>
				: 	<DarkCard classNames='mb-3 row'>
						<TxtTitles>Estimate status</TxtTitles>
						<span className="p-0" style={{color: `${Colors.green}`, fontWeight: 'bold'}}>
							<FontAwesomeIcon icon={faCheckCircle} className="me-2"/>
							{t("project.selected_title")}
						</span>
					</DarkCard>
			: null
		}

        {(!session_data) && 

			<DarkCard classNames='mb-3 row'>
				<LightCard classNames='mb-3'>
					<RedHeader title={t("common.titles.organise_calc")} />
					<div>
						<input
							type='radio'
							name="folder_type"
							id="select_type_folder_1"
							checked={folderTypeSelection === 'select_folder'}
							value="select_folder"
							onChange={() => radioButtonHandle("select_folder")}
							required="required"
						/>
						<label style={{paddingLeft:"10px"}} htmlFor="select_type_folder_1">
							{t("common.button.select_folder")}
						</label>
					</div>

					<div>
						<input
							type='radio'
							name="folder_type"
							id="select_type_folder_2"
							checked={folderTypeSelection === 'new_folder'}
							value="new_folder"
							onChange={() => radioButtonHandle("new_folder")}
							required="required"
						/>
						<label style={{paddingLeft:"10px"}} htmlFor="select_type_folder_2">
							{t("common.button.new_folder")}
						</label>
					</div>

					{folderTypeSelection === 'new_folder'
						? <div className="mt-2">
							<b>{t("common.titles.new_folder_name")}</b><br/>
							<input
								name="new_folder"
								type="text"
								value={calculation.folder || ""}
								onChange={(e) => {
									setFolder(e.target.value);
									setIsNotSaved(true);
								}}
							/>
						</div>
						: <Select
							options={foldersList}
							value={calculation.folder ? {label: calculation.folder, value: calculation.folder} : default_value}
							onChange={val => {
								setFolder(val.value);
								setIsNotSaved(true);
							}}
							styles={select_styles}
							isSearchable={true}
							unstyled
							className="mt-2"
						/>
					}
				</LightCard>
			</DarkCard>

		}

		<DarkCard classNames='mb-3 row'>
			<div>
				<Button
					className='me-4'
					variant='round'
					style={{backgroundColor: `${Colors.green}`}}
					name='save'
					onClick={() => saveHandler("save")}>
					{t("common.button.save")}
				</Button>

				{params.key && (
					<>
						<Button
							className='me-4'
							variant='round'
							style={{backgroundColor: `${Colors.orange}` }}
							name='save'
							onClick={() => saveHandler("save_as")}>
							{t("common.button.save_as_new")}
						</Button>

						{((!session_data) || (session_data && !session_data.currentFirst)) &&
							<Button
								className='me-4'
								variant='round'
								style={{ backgroundColor: Colors.red }}
								name='delete'
								onClick={() => handleCalculDelete({})}>
								{t("common.button.delete")}
							</Button>
						}

						{session_data
							?
							<Button
								className='me-4 pull-right'
								variant='round'
								style={{ backgroundColor: Colors.purple }}
								name='quote'
								onClick={handleQuote}>
								{t("common.button.create_quote")}
							</Button>
							:	
							<Button
								className='me-4 pull-right'
								variant='round'
								style={{ backgroundColor: Colors.skyBlue }}
								name='offer'
								onClick={() => handleOffer()}>
								{t("common.button.create_project")}
							</Button>
						}

					</>
				)}
			</div>
		</DarkCard>
		{popup.show ? (
			<PopupForm
				handlePopup={popup.deleteStatus ? handleCalculDelete : handlePopup}
				variant={popup.variant}
				title={t(popup.title)}
				message={t(popup.message)}
				leftBtn={popup.leftBtn}
				rightBtn={popup.rightBtn}
				okBtn={popup.okBtn}
				context={popup.context}
			/>
		) : null}
	</>);
}
export default Calculator;
